import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactRouteImpl } from "abreact/incubator/ui/app/router/ReactRouteImpl";
// If AbSDKRouteSpec was a class, these would be the public methods.
// import {RouterUtils} from "abreact/incubator/ui/app/router/RouterUtils";
// It is required to be immutable as used by across multiple major route lifecycles.
// The backing RouteHandler is responsible for holding any state throughout to a major route lifecycle (e.g., callbacks)

import { ProfileUtils } from "abweb/utils/profile/ProfileUtils";
export class RouteSpecHelper {
  constructor(routeSpec) {
    _defineProperty(this, "routeSpec", void 0);
    _defineProperty(this, "registeredRoutes", void 0);
    _defineProperty(this, "viewImportSpec", void 0);
    this.routeSpec = routeSpec;
    this.registeredRoutes = [this.routeSpec.routeTemplate];
    this.viewImportSpec = this.calcViewCmpImportSpec();
  }
  calcViewCmpImportSpec() {
    // Add profiling support, which will show transitive import overhead
    // Assume view component name (exportName) is unique among all views.  If not, could output route as part of label.
    const profiledModPathFn = () => ProfileUtils.elapsedAsync("Module import of route view: " + this.routeSpec.view.exportName, this.routeSpec.view.modulePath);
    const importSpec = {
      importModuleFn: profiledModPathFn,
      exportName: this.routeSpec.view.exportName
    };
    // ViewImportRegistrySingleton.registerImportSpec(importSpec.modulePath, importSpec.exportName);
    return importSpec;
  }
  isRouteRegistered(routeTemplate) {
    return this.registeredRoutes.includes(routeTemplate);
  }

  //////   Route Parameter and View Property Methods //////

  // Only called for route templates that belong to this route
  buildRouteProps(routeParams) {
    const props = this.routeSpec.routeParamHandler?.propsFromParams(routeParams) ?? {};
    return props;
  }
  buildRouteFromParams(routeParams) {
    const props = this.buildRouteProps(routeParams);
    return new ReactRouteImpl(this.routeSpec.routeTemplate, props, routeParams.routeParams, routeParams.routeExtraParams);
  }
  buildRouteFromProps(routeProps) {
    const params = this.routeSpec.routeParamHandler?.paramsFromProps(routeProps);
    return new ReactRouteImpl(this.routeSpec.routeTemplate, routeProps, params?.routeParams, params?.routeExtraParams);
  }

  /**
   * @param routeSpec Optionally provide the routeSpec, defaults to the internal routeSpec
   * @return array of exportNames of HOC functions and the view component, in that order */
  getViewExportNames(routeSpec) {
    routeSpec = routeSpec ?? this.routeSpec;
    const retVal = [];
    routeSpec.view.hocFnImportSpecs?.forEach(hocImportSpec => retVal.push(hocImportSpec.exportName));
    retVal.push(routeSpec.view.exportName);
    return retVal;
  }
}
//# sourceMappingURL=RouteSpecHelper.js.map
